import { render } from "./PersonalDataConsent.vue?vue&type=template&id=d9a72560&scoped=true"
import script from "./PersonalDataConsent.vue?vue&type=script&lang=js"
export * from "./PersonalDataConsent.vue?vue&type=script&lang=js"

import "./PersonalDataConsent.vue?vue&type=style&index=0&id=d9a72560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a72560"]])

export default __exports__